let contactPeople = [
  { 
    name: "Iulia Blîndu", 
    function: "contact.contactperson.coordinator" , 
    img: "https://i.imgur.com/AtH15Ck.png", 
    phone: "0737448032", 
    email: "iulia.blindu@eestec.ro" 
  },
  { 
    name: "Iulia Iacob", 
    function: "contact.contactperson.president" , 
    img: "https://i.imgur.com/rGelSNS.png", 
    phone: "0726179864", 
    email: "iulia.iacob@eestec.ro " 
  }
]

export default contactPeople;